import PolicyDocumentPage from '../components/PolicyDocumentPage';

/**
 * Public Terms of Use page at `/terms` (tasks 422, 441).
 *
 * Rendered on the public branch in App.tsx — reachable pre-auth (from the
 * Keycloak registration page, task 421) and pre-consent (from the ConsentGate
 * interstitial). Renders the current PUBLISHED document from AMS via the
 * innovate-service public proxy — the exact text the consent ledger's
 * `(terms_of_use, version)` rows refer to.
 */
export default function TermsOfUsePage() {
  return <PolicyDocumentPage type="terms_of_use" title="Terms of Use" />;
}
